export default {
    'diagram3-3a2': {
        'diagram-task': 'Fill in the rough summary and the simplified summary',

        'fixed-answer1': 'Once formed, habits are stubborn',
        'fixed-answer2': 'We indulge in habits because our brains encourage us to do so',
        'pre-fill': 'We indulge in habits',

        'fixed-answer3': 'The <u>brain</u> automatically evaluates whether an action rewards or punishes us, <u>positively weighting actions that reward</u>',
        'fixed-answer4': 'It monitors the positive rewards, <u>shifting</u> them <u>from deliberate to habitual</u> over time',
        'fixed-answer5': 'The habits then become so ingrained that we perform them even when we do not want to',
    }
};



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a2/diagram3/i18n/en.js